import {
  useLocation,
  useNavigate,
  useParams,
} from 'react-router';


// Adapter for class components that still read `location` / `match.params`
// from props (react-router v5 style). Function components use hooks directly.
const withRouter = (Component) => {
  const WithRouter = (props) => {
    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams();
    return (
      <Component
        {...props}
        location={location}
        navigate={navigate}
        match={{ params }}
      />
    );
  };
  WithRouter.displayName = `withRouter(${Component.displayName || Component.name || 'Component'})`;
  return WithRouter;
};

export default withRouter;
